module.exports = __webpack_public_path__ + "static/media/carlos_gonzalez_c.624ab452.jpg";